import InvoicingBase from "./InvoicingBase";
import Confirm from "./Confirm";
export default {
  INVOICING_BASE: InvoicingBase,
  CONFIRM: Confirm,
};
